import React, { useState } from "react";
import { toast } from "material-react-toastify";
import { portfolioData } from "../data/portfolioData";
import emailjs from "@emailjs/browser";

import { REACT_APP_EMAILJS_SERVICE_ID,REACT_APP_EMAILJS_TEMPLATE_ID,REACT_APP_EMAILJS_PUBLIC_KEY } from "../config.js";

const initialForm = {
  name: "",
  email: "",
  message: "",
};

const validateForm = (values) => {
  const errors = {};
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!values.name.trim()) {
    errors.name = "Name is required.";
  } else if (values.name.trim().length < 2) {
    errors.name = "Name must be at least 2 characters.";
  }

  if (!values.email.trim()) {
    errors.email = "Email is required.";
  } else if (!emailPattern.test(values.email.trim())) {
    errors.email = "Enter a valid email address.";
  }

  if (!values.message.trim()) {
    errors.message = "Message is required.";
  } else if (values.message.trim().length < 20) {
    errors.message = "Message must be at least 20 characters.";
  }

  return errors;
};

const Contact = () => {
  const { email, linkedin, sections, contact } = portfolioData;
  const [formValues, setFormValues] = useState(initialForm);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const onSubmit = async (event) => {
  event.preventDefault();

  const errors = validateForm(formValues);
  setFormErrors(errors);

  if (Object.keys(errors).length > 0) {
    toast.error(Object.values(errors)[0]);
    return;
  }

  try {
    setIsSubmitting(true);

     await emailjs.send(
      REACT_APP_EMAILJS_SERVICE_ID,
       "template_v0kzoy8",
      {
         name: formValues.name,
        email: 'chetan.jindal96@gmail.com',
        message: formValues.message,
        time: new Date().toLocaleString(),
      },
      REACT_APP_EMAILJS_PUBLIC_KEY
    );


    await emailjs.send(
      REACT_APP_EMAILJS_SERVICE_ID,
      REACT_APP_EMAILJS_TEMPLATE_ID,
      {
        name: formValues.name,
        email: formValues.email,   // <-- Add this
        title: formValues.message, // Or use another field if you have a title
        message: "Your message has been received. I will get back to you soon.",
      },
      REACT_APP_EMAILJS_PUBLIC_KEY
    );

    setFormValues(initialForm);

    toast.success(
      "Message sent successfully. I will get back to you soon."
    );
  } catch (error) {
    console.error(error);

    toast.error("Failed to send message. Please try again later.");
  } finally {
    setIsSubmitting(false);
  }
};

  // const onSubmit = async (event) => {
  //   event.preventDefault();
  //   const errors = validateForm(formValues);
  //   setFormErrors(errors);

  //   if (Object.keys(errors).length > 0) {
  //     const firstError = Object.values(errors)[0];
  //     toast.error(firstError);
  //     return;
  //   }

  //   // setIsSubmitting(true);
  //   // window.setTimeout(() => {
  //   //   setIsSubmitting(false);
  //   //   setFormValues(initialForm);
  //   //   toast.success("Message sent successfully. I will get back to you soon.");
  //   // }, 500);

  //   await emailjs.send(
  //     Config.REACT_APP_EMAILJS_SERVICE_ID,
  //     Config.REACT_APP_EMAILJS_TEMPLATE_ID,
  //     {
  //       from_name: formValues.name,
  //       from_email: formValues.email,
  //       message: formValues.message,
  //     },
  //     Config.REACT_APP_EMAILJS_PUBLIC_KEY
  //   );
  // };

  const inputClass = (field) =>
    `mt-2 w-full rounded-xl border bg-slate-950 px-3 py-3 text-sm text-slate-100 outline-none transition ${
      formErrors[field]
        ? "border-rose-400 focus:border-rose-400"
        : "border-slate-700 focus:border-cyan-300"
    }`;

  return (
    <section id="contact" className="py-16 scroll-mt-24">
      <div className="mx-auto grid max-w-6xl gap-6 px-4 lg:grid-cols-[0.85fr_1.15fr]">
        <div className="rounded-3xl border border-slate-700/60 bg-slate-900/60 p-7">
          <h2 className="text-3xl font-bold text-white">{sections.contactTitle}</h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-300">
            {contact.introPrefix}{" "}
            <a href={`mailto:${email}`} className="text-cyan-300 hover:text-cyan-200">
              {email}
            </a>{" "}
            {contact.introConnector}{" "}
            <a
              href={linkedin}
              target="_blank"
              rel="noreferrer"
              className="text-cyan-300 hover:text-cyan-200"
            >
              {contact.linkedinLabel}
            </a>
            {contact.introSuffix}
          </p>
        </div>

        <form
          className="grid gap-4 rounded-3xl border border-slate-700/60 bg-slate-900/50 p-7 text-sm"
          onSubmit={onSubmit}
          noValidate
        >
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <label className="block text-xs font-semibold uppercase tracking-[0.16em] text-slate-300">
                {contact.form.nameLabel}
              </label>
              <input
                type="text"
                name="name"
                value={formValues.name}
                onChange={onInputChange}
                className={inputClass("name")}
                placeholder={contact.form.namePlaceholder}
              />
              {formErrors.name && (
                <p className="mt-1 text-xs text-rose-300">{formErrors.name}</p>
              )}
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-[0.16em] text-slate-300">
                {contact.form.emailLabel}
              </label>
              <input
                type="email"
                name="email"
                value={formValues.email}
                onChange={onInputChange}
                className={inputClass("email")}
                placeholder={contact.form.emailPlaceholder}
              />
              {formErrors.email && (
                <p className="mt-1 text-xs text-rose-300">{formErrors.email}</p>
              )}
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-[0.16em] text-slate-300">
              {contact.form.messageLabel}
            </label>
            <textarea
              rows="5"
              name="message"
              value={formValues.message}
              onChange={onInputChange}
              className={inputClass("message")}
              placeholder={contact.form.messagePlaceholder}
            />
            {formErrors.message && (
              <p className="mt-1 text-xs text-rose-300">{formErrors.message}</p>
            )}
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-fit rounded-full bg-cyan-300 px-6 py-3 text-sm font-semibold text-slate-900 transition hover:bg-cyan-200 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isSubmitting ? "Sending..." : contact.form.submitLabel}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
